<div [class.selected]="checked" [class.no-content]="noContent" [class.disabled]="disabled" [class.simple]="simple"
  class="{{checkStyle}}">
  <ng-content></ng-content>
</div>
